//outsource
import { Col, Form, Row } from "antd";

//components
import ConsultationFirstName from "./component/consultation_first_name";
import ConsultationLastName from "./component/consultation_last_name";
import ConsultationPhone from "./component/consultation_phone";
import ConsultationEmail from "./component/consultation_email";
import ConsultationNote from "./component/consultation_note";
import ConsultationPhoto from "./component/consultation_photo";
import ConsultationLocation from "./component/consultation_location";

const SelectInformation = ({
  form,
  onFinish,
  onFinishFailed,
  onPhotosChange,
}) => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ConsultationFirstName />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ConsultationLastName />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ConsultationPhone />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ConsultationEmail />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ConsultationLocation />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ConsultationPhoto onPhotosChange={onPhotosChange} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <ConsultationNote />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      {/* <Form
        id="consultation"
        type="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        validateTrigger="onFinish"
      > */}
      {renderBody()}
      {/* </Form> */}
    </>
  );
};

export default SelectInformation;
